import * as React from 'react';
// import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { ITermParentProps, ITermParentState } from './ITaxonomyPicker';
import { ITerm } from '../../../interfaces/services/ISPTermStorePickerService';
import { EXPANDED_IMG, COLLAPSED_IMG, TERMSET_IMG, TERM_IMG } from './TaxonomyPicker';
import Term from './Term';
import "./TaxonomyPicker.css";
// import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { LanguageContext } from "../../../../../utilities/LocalizationModule";
import { Checkbox, Spinner, SpinnerSize } from '@fluentui/react';

export default class TermParent extends React.Component<ITermParentProps, ITermParentState> {

  private _terms: ITerm[];
  private _anchorName: string;
  static contextType = LanguageContext

  constructor(props: ITermParentProps) {
    super(props);

    this._terms = this.props.termset.Terms;
    this.state = {
      loaded: true,
      expanded: true
    };
    this._handleClick = this._handleClick.bind(this);
  }

  public componentWillMount() {
    // fix term depth if anchroid for rendering
    if (this.props.anchorId) {
      const anchorTerm = this._terms.filter(t => t.Id.toLowerCase() === this.props.anchorId.toLowerCase()).shift();
      if (anchorTerm) {
        // Append ';' separator, as a suffix to anchor term path.
        const anchorTermPath = `${anchorTerm.PathOfTerm};`;
        this._anchorName = anchorTerm.Name;
        let anchorTerms: ITerm[] = this._terms.filter(t => t.PathOfTerm.substring(0, anchorTermPath.length) === anchorTermPath && t.Id !== anchorTerm.Id);

        anchorTerms = anchorTerms.map(term => {
          term.PathDepth = term.PathDepth - anchorTerm.PathDepth;

          return term;
        });

        this._terms = anchorTerms;
      }
    }
  }


  private _handleClick() {
    this.setState({
      expanded: !this.state.expanded
    });
  }

  private termSetSelectionChange = (ev: React.FormEvent<HTMLElement>, isChecked: boolean): void => {
    this.props.termSetSelectedChange(this.props.termset, isChecked);
  }

  public render(): JSX.Element {
    // Specify the inline styling to show or hide the termsets
    const styleProps: React.CSSProperties = {
      display: this.state.expanded ? 'block' : 'none'
    };

    let termElm: JSX.Element = <div />;

    // Check if the terms have been loaded
    if (this.state.loaded) {
      if (this._terms.length > 0) {
        let disabledPaths = [];
        termElm = (
          <div style={styleProps}>
            {
              this._terms.map(term => {
                let disabled = false;
                if (this.props.disabledTermIds && this.props.disabledTermIds.length > 0) {
                  // Check if the current term ID exists in the disabled term IDs array
                  disabled = this.props.disabledTermIds.indexOf(term.Id) !== -1;
                  if (disabled) {
                    // Push paths to the disabled list
                    disabledPaths.push(term.PathOfTerm);
                  }
                }

                if (this.props.disableChildrenOfDisabledParents) {
                  // Check if parent is disabled
                  const parentPath = disabledPaths.filter(p => term.PathOfTerm.indexOf(p) !== -1);
                  disabled = parentPath && parentPath.length > 0;
                }

                return <Term key={term.Id}
                  term={term}
                  termset={this.props.termset.Id}
                  activeNodes={this.props.activeNodes}
                  changedCallback={this.props.changedCallback}
                  multiSelection={this.props.multiSelection}
                  disabled={disabled}
                  termActions={this.props.termActions}
                  updateTaxonomyTree={this.props.updateTaxonomyTree}
                  spTermService={this.props.spTermService}
                />;
              })
            }
          </div>
        );
      } else {
        termElm = <div className={`listItem term`}>{this.context.TaxonomyPickerNoTerms}</div>;
      }
    } else {
      termElm = <Spinner size={SpinnerSize.medium} />;
    }


    return (
      <div>
        <div className={`listItem termset ${(!this.props.anchorId && this.props.isTermSetSelectable) ? 'termSetSelectable' : ""}`} onClick={this._handleClick}>
          <img src={this.state.expanded ? EXPANDED_IMG : COLLAPSED_IMG} alt={this.context.TaxonomyPickerExpandTitle} title={this.context.TaxonomyPickerExpandTitle} />
          {
            // Show the termset selection box
            (!this.props.anchorId && this.props.isTermSetSelectable) &&
            <Checkbox className={'termSetSelector'}
              checked={this.props.activeNodes.filter(a => a.path === "" && a.key === a.termSet).length >= 1}
              onChange={this.termSetSelectionChange} />
          }
          <img src={this.props.anchorId ? TERM_IMG : TERMSET_IMG} alt={this.context.TaxonomyPickerMenuTermSet} title={this.context.TaxonomyPickerMenuTermSet} />
          {
            this.props.anchorId ?
              this._anchorName :
              this.props.termset.Name
          }
        </div>
        <div style={styleProps}>
          {termElm}
        </div>
      </div>
    );
  }
}
